import Vue from 'vue';
import appBasic from '@/plugins/graphql/queries/v2/app-basic.gql';
import { TierType } from '@/helpers/entities/enums/v2/TierType';
import { StoreStatus } from '@/helpers/entities/enums/v2/StoreStatus';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
var BillingPaymentStatus;
(function (BillingPaymentStatus) {
    BillingPaymentStatus["ForPayment"] = "For Payment";
    BillingPaymentStatus["PaymentSubmitted"] = "Payment Submitted";
    BillingPaymentStatus["Paid"] = "Paid";
    BillingPaymentStatus["ForBilling"] = "For Billing";
})(BillingPaymentStatus || (BillingPaymentStatus = {}));
export default Vue.extend({
    mixins: [AlertMixin, RouterParamsAppMixin],
    apollo: {
        appBasic: {
            query: appBasic,
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update({ app }) {
                return app;
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            appBasic: null,
        };
    },
    computed: {
        subscribedToEnterprisePlan() {
            if (this.appBasic) {
                const { plan } = this.appBasic;
                return plan !== TierType.Free && plan !== TierType.FreeTier;
            }
            return false;
        },
        billingPaymenStatus() {
            const app = this.appBasic;
            const defaultStatus = BillingPaymentStatus.ForBilling;
            if (!app || (app && !app.withBillings)) {
                return defaultStatus;
            }
            if (app && app.billingsPaymentSettled) {
                return BillingPaymentStatus.Paid;
            }
            if (app && app.billingPaymentSubmitted) {
                return BillingPaymentStatus.PaymentSubmitted;
            }
            if (app && app.withOutstandingBalance) {
                return BillingPaymentStatus.ForPayment;
            }
            return defaultStatus;
        },
        isNewApp() {
            return this.billingPaymenStatus === BillingPaymentStatus.ForBilling;
        },
        storeActive() {
            return !!this.appBasic && this.appBasic.storeStatus === StoreStatus.Active;
        },
        storeClosed() {
            return !!this.appBasic && this.appBasic.storeStatus === StoreStatus.Closed;
        },
    },
    methods: {
        refetch() {
            this.$apollo.queries.appBasic.refetch();
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                app: this.appBasic,
                enterprisePlan: this.subscribedToEnterprisePlan,
                refetch: this.refetch,
                billingPaymenStatus: this.billingPaymenStatus,
                isNewApp: this.isNewApp,
                storeActive: this.storeActive,
                storeClosed: this.storeClosed,
            });
        }
    },
});
